import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@shared/services/api.service';
import {
  ForgotPasswordApiPayload,
} from '../models/forgot-password-api.model';
import {
  ForgotPasswordResetApiPayload,
} from '../models/forgot-password-reset-api.model';

@Injectable({
  providedIn: 'root',
})
export class ForgotPasswordApiService {

  static apiContext = 'password';

  private _apiService = inject(ApiService);

  requestEmail$(payload: ForgotPasswordApiPayload): Observable<void | null> {
    return this._apiService.post<void>({
      url: `${ ForgotPasswordApiService.apiContext }/email`,
      body: payload,
    });
  }

  reset$(payload: ForgotPasswordResetApiPayload): Observable<void | null> {
    return this._apiService.post<void>({
      url: `${ ForgotPasswordApiService.apiContext }/reset`,
      body: payload,
    });
  }
}
